<template>
    <tabs nav-style="tabs" v-model="activeTabIndex">
        <tab header="MOA">
            <h3>MOA</h3>
            <div class="wrapper">
                <loader v-if="loading" />
                <form v-if="!loading" class="form form-horizontal" @submit.prevent data-vv-scope="moa">
                    <div class="form-group">
                        <label class="col-md-2 control-label">DB Number</label>
                        <div class="col-md-9" style="margin-top: 10px;">{{ moa.dbnumber}}</div>
                    </div>
                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('moa.moaName') }">
                        <label class="col-md-2 control-label">MOA Name</label>
                        <div class="col-md-9">
                            <input v-model="moa.moaName" v-validate="'required|max:255'" name="moaName"
                                class="form-control" type="text" :disabled="!isPrimaryUser" aria-required="true" />
                            <span v-show="errors.has('moa.moaName') && moa.moaName.length === 0" class="has-error">MOA
                                Name is required</span>
                            <span v-show="errors.has('moa.moaName') && moa.moaName.length > 255" class="has-error">MOA
                                Name cannot be longer than 255 characters</span>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Responsible Federal Agency</label>
                        <div class="col-md-9">
                            <select v-model="selectedAgencyId" name="agencyId" class="form-control"
                                :disabled="!isPrimaryUser">
                                <option disabled value="">Select a value</option>
                                <option v-for="blm in agencyOrgList" :key="blm.id" :value="blm.id">{{ blm.description}}
                                </option>
                            </select>
                            <span
                                v-show="selectedLeadAgency && selectedLeadAgency.hasUsers === false && !selectedLeadAgency.agencyNoReview"
                                class="has-error">
                                Selected Federal Agency has no Wyotrack users
                            </span>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Secondary Federal Agencies</label>
                        <div class="col-md-9">
                            <v-select v-model="secondaryAgencyOrgs" :options="agencyOrgList" name="secondaryAgencyIds"
                                label="description" style="background-color: #fafafa" multiple
                                :disabled="!isPrimaryUser" />
                        </div>
                    </div>
                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('moa.agencyNo') }">
                        <label class="col-md-2 control-label">Agency Number</label>
                        <div class="col-md-9">
                            <input v-validate="'max:255'" v-model="moa.agencyNo" class="form-control" type="text"
                                name="agencyNo" :disabled="!isPrimaryUser" />
                            <span v-show="errors.has('moa.agencyNo')" class="has-error">Agency Number cannot be longer
                                than 255 characters</span>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Effective Date</label>
                        <div class="col-md-6">
                            <el-date-picker v-model="moa.effectiveDate" type="date" format="MM/dd/yyyy"
                                placeholder="Select Effective Date" :disabled="!isPrimaryUser && !isSecondaryUser" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Stipulations</label>
                        <div class="col-md-9">
                            <button :disabled="!moa.moaId || (!isPrimaryUser && !isSecondaryUser)"
                                v-if="!isUnknownUser"
                                class="btn btn-primary" type="button" name="addStipulation"
                                v-on:click="createNewStipulation()">Add Stipulation</button>
                            <v-client-table :data="stipGridSpec.tableData" :columns="stipGridSpec.columns"
                                :options="stipGridSpec.options" ref="stipulationTable">
                                <template slot="edit" slot-scope="props" v-if="!isUnknownUser">
                                    <div style="text-align: center;">
                                        <a class="fa fa-edit" style="font-size: 18px;"
                                            v-on:click="$refs['stipulation' + props.index][0].open()"></a>
                                    </div>
                                </template>
                            </v-client-table>
                            <modal v-for="(stipulation, index) in moa.moaStipulationList" :key="index"
                                :ref="'stipulation' + index">
                                <div slot="header" class="">
                                    <h3 class="pull-left">Stipulation</h3>
                                </div>
                                <div slot="body">
                                    <div class="">
                                        <form class="form form-horizontal" @submit.prevent data-vv-scope="stipulation">
                                            <div class="form-group"
                                                v-bind:class="{ 'has-error': errors.has('stipulation.stipHeading') }">
                                                <label class="col-xs-3 control-label">Stipulation Heading</label>
                                                <div class="col-xs-9">
                                                    <input class="form-control" type="text" name="stipHeading"
                                                        v-model="stipulation.stipulationHeading" v-validate="'required'"
                                                        aria-required="true"></input>
                                                    <span v-show="errors.has('stipulation.stipHeading')"
                                                        class="has-error">Stipulation Heading is required</span>
                                                </div>
                                            </div>
                                            <div class="form-group"
                                                v-bind:class="{ 'has-error': errors.has('stipulation.stipDescription') }">
                                                <label class="col-xs-3 control-label">Stipulation Description</label>
                                                <div class="col-xs-9">
                                                    <textarea class="form-control" name="stipDescription" rows="5"
                                                        v-model="stipulation.stipulationDescription"
                                                        v-validate="'required'" aria-required="true"></textarea>
                                                    <span v-show="errors.has('stipulation.stipDescription')"
                                                        class="has-error">Stipulation Description is required</span>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="col-xs-3 control-label">Has Due Date</label>
                                                <div class="col-xs-6">
                                                    <div class="checkbox">
                                                        <input :id="'dueDate' + index" type="checkbox" name="hasDueDate"
                                                            v-model="stipulation.hasDueDate"></input>
                                                        <label :for="'dueDate' + index"></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="stipulation.hasDueDate" class="form-group">
                                                <label class="col-xs-3 control-label">Due Date</label>
                                                <div class="col-xs-6">
                                                    <el-date-picker style="z-index: 9999;" v-model="stipulation.dueDate"
                                                        type="date" format="MM/dd/yyyy"
                                                        placeholder="Select Due Date"></el-date-picker>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="col-xs-3 control-label">Complete Date</label>
                                                <div class="col-xs-6">
                                                    <el-date-picker v-model="stipulation.completeDate" type="date"
                                                        format="MM/dd/yyyy"
                                                        placeholder="Select Complete Date"></el-date-picker>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div slot="footer">
                                    <div class="">
                                        <button class="btn btn-primary col-xs-5" type="button" name="close"
                                            v-on:click="validateStipulation(index)">Finish Editing and Close</button>
                                    </div>
                                </div>
                            </modal>
                            <modal ref="newStipulationModal">
                                <div slot="header" class="">
                                    <h3 class="pull-left">Stipulation</h3>
                                    <button class="btn pull-right"
                                        v-on:click="$refs['newStipulationModal'].close()">X</button>
                                </div>
                                <div slot="body">
                                    <div class="">
                                        <form class="form form-horizontal" @submit.prevent
                                            data-vv-scope="stipulationNew">
                                            <div class="form-group"
                                                v-bind:class="{ 'has-error': errors.has('stipulationNew.stipHeading') }">
                                                <label class="col-xs-3 control-label">Stipulation Heading</label>
                                                <div class="col-xs-9">
                                                    <input class="form-control" type="text" name="stipHeading"
                                                        v-model="newStipulation.stipulationHeading"
                                                        v-validate="'required'" aria-required="true"></input>
                                                    <span v-show="errors.has('stipulationNew.stipHeading')"
                                                        class="has-error">Stipulation Heading is required</span>
                                                </div>
                                            </div>
                                            <div class="form-group"
                                                v-bind:class="{ 'has-error': errors.has('stipulationNew.stipDescription') }">
                                                <label class="col-xs-3 control-label">Stipulation Description</label>
                                                <div class="col-xs-9">
                                                    <textarea class="form-control" type="text" name="stipDescription"
                                                        rows="5" v-model="newStipulation.stipulationDescription"
                                                        v-validate="'required'" aria-required="true"></textarea>
                                                    <span v-show="errors.has('stipulationNew.stipDescription')"
                                                        class="has-error">Stipulation Description is required</span>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="col-xs-3 control-label">Has Due Date</label>
                                                <div class="col-xs-6">
                                                    <div class="checkbox">
                                                        <input id="hasDueDateNew" type="checkbox" name="hasDueDate"
                                                            v-model="newStipulation.hasDueDate">
                                                        <label for="hasDueDateNew"></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="newStipulation.hasDueDate" class="form-group">
                                                <label class="col-xs-3 control-label">Due Date</label>
                                                <div class="col-xs-6">
                                                    <el-date-picker v-model="newStipulation.dueDate" type="date"
                                                        format="MM/dd/yyyy"
                                                        placeholder="Select Due Date"></el-date-picker>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="col-xs-3 control-label">Complete Date</label>
                                                <div class="col-xs-6">
                                                    <el-date-picker v-model="newStipulation.completeDate" type="date"
                                                        format="MM/dd/yyyy"
                                                        placeholder="Select Complete Date"></el-date-picker>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div slot="footer">
                                    <div class="">
                                        <button class="btn btn-primary col-xs-5" type="button" name="close"
                                            v-on:click="saveNewStipulation">Finish Creating and Close</button>
                                    </div>
                                </div>
                            </modal>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Undertaking</label>
                        <div class="col-md-9">
                            <button v-on:click="$refs['undertakingAssignModal'].open()" class="btn btn-primary"
                                type="button" name="assignUndertaking"
                                :disabled="!moa.moaId || (isUnknownUser)"
                                v-if="!isUnknownUser"
                            >Assign Undertaking</button>
                            <v-client-table :data="utGridSpec.tableData" :columns="utGridSpec.columns"
                                :options="utGridSpec.options" ref="undertakingTable">
                                <template slot="edit" slot-scope="props" v-if=!isUnknownUser>
                                    <div style="text-align: center;">
                                        <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="editUndertakingRow(props.row.undertakingId)"></a> -->
                                        <router-link :to="{ path: '/Undertaking/' + props.row.undertakingId }" tag="a"
                                            class="fa fa-edit" style="font-size: 16px;"></router-link>
                                    </div>
                                </template>
                                <template slot="remove" slot-scope="props" v-if=!isUnknownUser>
                                    <div style="text-align: center;">
                                        <button class="btn"
                                            v-on:click="removeUndertaking(props.row.undertakingId)">Remove</button>
                                    </div>
                                </template>
                            </v-client-table>
                            <modal ref="undertakingAssignModal">
                                <div slot="header" class="">
                                    <h3 class="pull-left">Assign An Undertaking</h3>
                                    <button class="btn pull-right"
                                        v-on:click="$refs['undertakingAssignModal'].close()">X</button>
                                </div>
                                <div slot="body">
                                    <h4>Search Undertaking</h4>
                                    <div class="">
                                        <form @submit.prevent="loadData" class="form-horizontal">
                                            <div class="form-group">
                                                <div class="col-sm-2">
                                                    <label for="searchDbNumber">DB Number</label>
                                                </div>
                                                <div class="col-sm-2">
                                                    <input class="form-control" type="text" name="searchDbNumber"
                                                        v-model="utSearchDto.dbNumber">
                                                </div>
                                                <div class="col-sm-2 col-sm-offset-1">
                                                    <label for="searchName">Name</label>
                                                </div>
                                                <div class="col-sm-5">
                                                    <input class="form-control" type="text" name="searchName"
                                                        v-model="utSearchDto.name">
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="col-md-2">
                                                    <label for="searchAgnecyNo">Agency Number</label>
                                                </div>
                                                <div class="col-md-4">
                                                    <input class="form-control" type="text" name="searchAgnecyNo"
                                                        v-model="utSearchDto.agencyNumber">
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="col-md-2">
                                                    <button class="btn btn-primary" type="submit" name="button"
                                                        v-on:click="loadUnassignedUndertakings()">Search</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="">
                                        <v-client-table :data="utAllGridSpec.tableData" :columns="utAllGridSpec.columns"
                                            :options="utAllGridSpec.options">
                                            <template slot="assign" slot-scope="props">
                                                <div style="text-align: center;">
                                                    <button class="btn"
                                                        v-on:click="assignUndertaking(props.row.undertakingId)">Assign</button>
                                                </div>
                                            </template>
                                        </v-client-table>
                                    </div>
                                </div>
                                <div slot="footer">
                                    <div class="">
                                        <button class="btn btn-primary col-md-3" type="button" name="cancel"
                                            v-on:click="$refs['undertakingAssignModal'].close()">Close</button>
                                    </div>
                                </div>
                            </modal>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">&nbsp;</label>
                        <div class="col-md-4">
                            <validationResultDisplay :validationResult="validationResult"></validationResultDisplay>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-offset-2" v-if="!isUnknownUser">
                            <hr />
                            <button class="btn btn-primary" type="submit" name="submit" style="width:100px;" v-on:click="saveMoa">
                                {{moaId ? 'Save' : 'Create'}}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </tab>
        <tab header="Documents">
            <moaPaDocuments v-if="$route.params.moaId" :moaId="$route.params.moaId" :loadOnMount="false"
                ref="moaDocuments"></moaPaDocuments>
            <div style="margin-top: 20px;">
                <hr />
                <mediaLetter :mediaTypeId="mediaTypeIdMoaLetter" :parentId="moaId" :loadOnMount="false"
                    ref="mediaLetter"></mediaLetter>
            </div>
        </tab>
        <tab v-if="$route.params.moaId && isPrimaryUser" header="Workflow"
            :disabled="!$route.params.moaId || !isPrimaryUser">
            <div style="margin-top: 20px;">
                <workflow :workflowId="moaWorkflowId" :parentId="moaId" ref="workflow"
                    v-on:workflowOnSubmitSuccess="workflowOnSubmitSuccess" />
            </div>
            <div v-if="checkShpoRole" style="margin-top: 20px;">
                <quickLetter :moaId="moaId" :mediaTypeId="mediaTypeIdMoaLetter" :parentId="moaId"></quickLetter>
            </div>
        </tab>
    </tabs>
</template>

<script>
    import loggingService from '../services/util/loggingService'
    import moaService from '../services/moaService'
    import dateService from '../services/util/dateService'
    import undertakingService from '@/services/undertakingService'
    import organizationService from '@/services/organizationService'
    import workflowService from '../services/workflowService'
    import mediaService from '../services/mediaService'
    import roleService from '../services/roleService.js'
    import userService from '@/services/userService.js'
    import { mapState } from 'vuex'

    import loader from '@/components/Loader.vue'
    import modal from '@/components/Modal.vue'
    import { tab, tabs } from 'vue-strap'
    import workflow from '../components/Workflow.vue'
    import mediaLetter from '../components/MediaLetter.vue'
    import quickLetter from '../components/QuickLetter.vue'
    import moaPaDocuments from '../components/MoaPaDocuments.vue'
    import validationResultDisplay from '@/components/ValidationResultDisplay.vue'

    export default {
        components: {
            loader,
            modal,
            tabs,
            tab,
            workflow,
            moaPaDocuments,
            mediaLetter,
            quickLetter,
            validationResultDisplay
        },
        data: function () {
            return {
                isDebug: false,
                loading: true,
                activeTabIndex: 0,
                moa: {},
                agencyOrgList: [],
                secondaryAgencyOrgs: [], // as agencyOrgList item []
                newStipulation: {},
                stipGridSpec: {
                    columns: ['edit', 'stipulationHeading', 'dueDateDisplay', 'completeDateDisplay'],
                    options: {
                        dateFormat: 'YYYY-MM-DD',
                        perPage: 10,
                        perPageValues: [5, 10, 25, 50, 100],
                        dateColumns: ['dueDate', 'completeDate'],
                        headings: {
                            stipulationHeading: 'Stipulation',
                            dueDateDisplay: 'Due Date',
                            completeDateDisplay: 'Complete Date'
                        }
                    },
                    tableData: []
                },
                utGridSpec: {
                    columns: ['edit', 'dbNumber', 'name', 'agencyDescription', 'agencyUndertakingNo', 'effect', 'createdDate', 'remove'],
                    options: {
                        dateFormat: 'YYYY-MM-DD',
                        perPage: 10,
                        perPageValues: [10, 25, 50, 100],
                        dateColumns: ['createdDate'],
                        headings: {
                            name: 'Name',
                            dbNumber: 'DB Number',
                            agencyDescription: 'Agency',
                            agencyUndertakingNo: 'Agency No',
                            effect: 'Finding of Effect',
                            createdDate: 'Created Date'
                        },
                        orderBy: {
                            ascending: false,
                            column: 'reportdDate'
                        },
                        filterable: false
                    },
                    tableData: []
                },
                utAllGridSpec: {
                    columns: ['assign', 'dbNumber', 'name', 'agencyDescription', 'agencyUndertakingNo', 'effect', 'createdDate'],
                    tableData: [],
                    options: {
                        dateFormat: 'YYYY-MM-DD',
                        perPage: 5,
                        perPageValues: [5, 10, 25, 50, 100],
                        dateColumns: ['createdDate'],
                        headings: {
                            name: 'Name',
                            dbNumber: 'DB Number',
                            agencyDescription: 'Agency',
                            agencyUndertakingNo: 'Agency No',
                            effect: 'Finding of Effect',
                            createdDate: 'Created Date'
                        },
                        orderBy: {
                            ascending: false,
                            column: 'reportdDate'
                        }
                    }
                },
                utSearchDto: {
                    dbNumber: '',
                    name: '',
                    agencyNumber: ''
                },
                tabsEnum: {
                    moa: 0,
                    documents: 1,
                    workflow: 2,
                    workflowLoaded: false
                },
                validationResult: { messages: [] },
                selectedAgencyId: null,
                primaryAgencyOrgList: [] //not implemented yet. Use if we need to restrict Resp. Federal Agency List
            }
        },
        watch: {
            activeTabIndex: function (val) {
                loggingService.log(this.isDebug, 'Moa', 'watch.activeTabIndex: ' + val)
                switch (val) {
                case this.tabsEnum.moa:
                    break
                case this.tabsEnum.documents:
                    this.$refs.moaDocuments.loadMedia()
                    this.$refs.mediaLetter.loadMedia()
                    break
                case this.tabsEnum.workflow: //Workflow
                    if (!this.tabsEnum.workflowLoaded) {
                        this.$refs.workflow.loadData()
                        loggingService.log(this.isDebug, 'Moa', 'watch.activeTabIndex: ' + val + ', called: workflow.loadData')
                    }
                    this.tabsEnum.workflowLoaded = true
                    break
                }
            }
        },
        computed: {
            moaId: function () {
                return this.$route.params.moaId
            },
            moaWorkflowId: function () {
                return workflowService.WorkflowEnum.Moa
            },
            mediaTypeIdMoaLetter: function () {
                return mediaService.mediaType.MoaLetter
            },
            // compute current user info
            ...mapState({
                shpoUserDto: state => state.auth.shpoUserDto
            }),
            checkShpoRole: function () {
                return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoRoleList))
            },
            selectedLeadAgency: function () {
                return this.agencyOrgList.find(o => o.id === this.selectedAgencyId)
            },
            isUnknownUser: function () {
                return !this.isPrimaryUser && !this.isSecondaryUser
            },
            isSecondaryUser: function () {
                // if the user is not the primary user and in the secondary organizations
                return !this.isPrimaryUser && this.shpoUserDto.userOrganizationList &&
                    this.shpoUserDto.userOrganizationList
                        .map(o => o.organizationId)
                        .some(o => this.moa.secondaryAgencyIds.includes(o))
            },
            isPrimaryUser: function () {
                // if the user is an administrator or in the main organization
                return !this.moaId || userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoRoleList) ||
                    this.shpoUserDto.userOrganizationList
                        .map(o => o.organizationId)
                        .includes(this.moa.agencyId)
            }
        },
        mounted () {
            loggingService.log(this.isDebug, 'Undertakings', 'mounted')

            // since the packaged version of v-select doesn't come with a way to display one property while storing
            // another property in the model while getting a list of objects (a la item-value and item-description
            // in a v-select from vuetify 3), we must manually translate the secondaryAgencyIds array into the
            // objects filtered out of the agencyOrgList. since this introduces a dependency between loadData
            // and loadAgencyList, they must both be finshed before we can decode the secondary agencies
            Promise.all([
                this.loadAgencyList(),
                this.loadUnassignedUndertakings(),
                this.loadData()
            ]).then(_response => {
                this.secondaryAgencyOrgs = this.agencyOrgList.filter(aol => (this.moa.secondaryAgencyIds || []).includes(aol.id))
                //add selected agency if it's not in primary
                if (!this.primaryAgencyOrgList.includes(this.selectedAgencyId)) {
                    this.primaryAgencyOrgList.push(this.agencyOrgList.find(a => a.id === this.selectedAgencyId))
                }
                this.loading = false
            })
        },
        methods: {
            throwException () {
                moaService.throwException(this.$http)
            },
            async loadData () {
                return new Promise((resolve, reject) => {
                    loggingService.log(this.isDebug, 'MOA', `loading data moa:${this.$route.params.moaId}`)
                    if (this.$route.params.moaId) {
                        moaService.get(this.$http, this.$route.params.moaId).then(response => {
                            loggingService.log(this.isDebug, 'MOA', 'moaService.get.then')
                            this.moa = response.data
                            this.selectedAgencyId = this.moa.agencyId
                            if (this.moa.moaStipulationList) {
                                this.createStipDateDisplay()
                                this.stipGridSpec.tableData = this.moa.moaStipulationList
                            }

                            if (this.moa.undertakingList) {
                                this.moa.undertakingList.forEach(ut => {
                                    ut.createdDate = dateService.convertToDate(ut.createdDate)
                                })
                                this.utGridSpec.tableData = this.moa.undertakingList
                            }

                            return resolve()
                        }).catch((err) => {
                            return reject(err)
                        })
                    } else {
                        loggingService.log(this.isDebug, 'Undertaking', 'new moa')
                        this.createNewMoa()
                        return resolve()
                    }
                })
            },
            async loadUnassignedUndertakings () {
                return new Promise((resolve, reject) => {
                    loggingService.log(this.isDebug, 'MOA', 'loading unassignedUndertakings')
                    undertakingService.searchUnassigned(this.$http, this.utSearchDto).then(response => {
                        loggingService.log(this.isDebug, 'MOA', 'undertakingService.searchUnassigned.then')
                        this.utAllGridSpec.tableData = response.data //.filter(x => x.reqMoa)
                        return resolve()
                    }).catch((err) => {
                        return reject(err)
                    })
                })
            },
            async loadAgencyList () {
                return new Promise((resolve, reject) => {
                    loggingService.log(this.isDebug, 'MOA', 'loading BLM Organization List')
                    organizationService.listLeadAgencyLookup(this.$http).then(response => {
                        loggingService.log(this.isDebug, 'MOA', 'organizationService.listLeadAgencyLookup.then')
                        this.agencyOrgList = response.data
                        //restrict primary agency list
                        if (!this.checkShpoRole) {
                            this.primaryAgencyOrgList = this.agencyOrgList.filter(
                                x => this.shpoUserDto.userOrganizationList.some(y => y.organizationId === x.id)
                            )
                        }
                        return resolve()
                    }).catch((err) => {
                        return reject(err)
                    })
                })
            },
            createNewMoa () {
                this.moa = {
                    moaName: '',
                    agencyNo: '',
                    agencyId: null,
                    effectiveDate: null,
                    moaStipulationList: [],
                    undertakingList: [],
                    secondaryAgencyIds: []
                }
            },
            createNewStipulation () {
                this.newStipulation = {
                    moaId: this.moa.moaId,
                    stipulationHeading: '',
                    stipulationDescription: '',
                    hasDueDate: false,
                    dueDate: null,
                    completeDate: null
                }
                this.$refs['newStipulationModal'].open()
            },
            saveNewStipulation () {
                this.$validator.validateAll('stipulationNew').then(result => {
                    if (result) {
                        loggingService.log(this.isDebug, 'Moa', 'saveNewStipulation - form validated and saved')
                        this.moa.moaStipulationList.push(this.newStipulation)
                        this.createStipDateDisplay()
                        this.$refs.stipulationTable.refresh
                        this.$refs['newStipulationModal'].close()
                        this.newStipulation = {}
                    } else {
                        loggingService.log(this.isDebug, 'Moa', 'saveNewStipulation - invalid form')
                    }
                })
            },
            validateStipulation (index) {
                this.$validator.validateAll('stipulation').then(result => {
                    if (result) {
                        loggingService.log(this.isDebug, 'Moa', 'validateStipulation - valid form')
                        this.createStipDateDisplay()
                        this.$refs.stipulationTable.refresh
                        this.$refs['stipulation' + index][0].close()
                    } else {
                        loggingService.log(this.isDebug, 'Moa', 'validateStipulation - invalid form')
                    }
                })
            },
            saveMoa () {
                this.$validator.validateAll('moa').then(result => {
                    if (result) {
                        var confirmMsg = 'There are more than one Undertakings assigned to this MOA, continue to save?'
                        if (this.moa.undertakingList.length < 2 || confirm(confirmMsg)) {
                            this.validationResult = { messages: [] }
                            this.moa.agencyId = this.selectedAgencyId
                            this.moa.secondaryAgencyIds = this.secondaryAgencyOrgs.map(sao => sao.id)
                            this.loading = true
                            moaService.put(this.$http, this.moa).then(response => {
                                // ensure the page goes to the correct moa id route after creating a new moa
                                if (response.data.objectList && response.data.objectList.length > 0) {
                                    this.$router.push('/Moa/' + response.data.objectList[0].moaId)
                                    this.loadData()
                                } else {
                                    this.validationResult = response.data
                                }
                                loggingService.log(this.isDebug, 'Moa', 'saveMoa - complete')
                                this.loading = false
                            })
                        }
                    } else {
                        loggingService.log(this.isDebug, 'Moa', 'saveMoa - invalid form')
                    }
                })
            },
            createStipDateDisplay () {
                this.moa.moaStipulationList.forEach(row => {
                    row.dueDateDisplay = dateService.convertToDate(row.dueDate)
                    row.completeDateDisplay = dateService.convertToDate(row.completeDate)
                })
            },
            editUndertakingRow (id) {
                loggingService.log(this.isDebug, 'Moa', 'editRow, id: ' + id)
                this.$router.push('/Undertaking/' + id)
            },
            assignUndertaking (id) {
                if (confirm('Are you sure you want to assign this Undertaking to the MOA?')) {
                    // create the setMoa object
                    var setMoa = {
                        moaId: this.moa.moaId,
                        newUndertakingId: id
                        //oldUndertakingId: this.moa.undertakingList.length > 0 ? this.moa.undertakingList[0].undertakingId : null
                    }
                    //remove MOA assignment from old undertaking and assign to new undertaking
                    undertakingService.setMoa(this.$http, setMoa).then(response => {
                        loggingService.log(this.isDebug, 'Moa', 'new undertaking assigned to MOA')
                        Promise.all([this.loadData(), this.loadUnassignedUndertakings()])
                        this.$refs['undertakingAssignModal'].close()
                    })
                }
            },
            removeUndertaking (id) {
                if (confirm('Are you sure you want to remove this Undertaking from the MOA?')) {
                    // create the setMoa object
                    var setMoa = {
                        moaId: null,
                        newUndertakingId: id
                    }
                    // remove MOA assignment
                    undertakingService.setMoa(this.$http, setMoa).then(response => {
                        loggingService.log(this.isDebug, 'Moa', 'undertaking removed from MOA')
                        this.loadData()
                    })
                }
            },
            workflowOnSubmitSuccess (submitValidationResult) {
                //trigger media letter refresh if letter gen is triggered
                if (submitValidationResult.letterGenTriggered && this.$refs.mediaLetter) {
                    this.$refs.mediaLetter.autoRefreshMedia()
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Moa.vue?d5ce1cc2